<template>
  <div class="carousel-wrapper">
    <div class="carousel-header">mais visualizados hoje:</div>
    <v-carousel hide-delimiter-background :height="160" cycle :show-arrows="false" delimiter-icon="mdi-circle"
      color="white" :delimiter-icon-size="8" class="custom-carousel">
      <v-carousel-item v-for="car in processedViews" :key="car.id_avaliacao">
        <a href='#' @click="gotoCarMoreViews(car.url)">
          <v-card flat class="d-flex align-center pa-2 custom-card">

            <div style="position: relative">
              <v-img :src="car.foto" height="80" width="120" class="rounded mr-3" />
              <Heart :fill="isVehicleFavorite(car.id_avaliacao) ? '#ee2424' : '#00000000'"
                :color="isVehicleFavorite(car.id_avaliacao) ? '#ee2424' : 'white'" :size="18" class="heart-icon"
                @click.stop="handleSetFavorite(car.id_avaliacao)" />
            </div>
            <div class="d-flex flex-column justify-space-between custom-desc">
              <strong class="text-uppercase w-full" >{{ car.v_modelo }} <span v-if="car.qtdeVeic <= 1">{{ car.v_versao }}</span></strong>
              <div class="custom-desc d-flex flex-rown justify-space-between">
                <span class="text-caption grey--text">{{ car.data }}</span>
                <span class="text-caption text-black font-weight-bold text-right">
                  {{ car.remainingTime }}
                </span>
              </div>
              <div class="d-flex justify-space-between align-center">
                <span class="text-caption">{{ car.v_combustivel }}</span>
                <span class="font-weight-bold text-amber ml-4 text-right w-full max-w-full">{{ car.valor }}</span>
              </div>
            </div>

          </v-card>
        </a>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { gotoCarMoreViews } from "@/helpers/vdp";
import { Heart } from "lucide-vue-next";
import VehicleCardMixin from "@/views/buyer/mixins/VehicleCardMixin";
import { mapState } from "vuex";

export default {
  mixins: [VehicleCardMixin],
  components: {
    Heart,
  },
  data() {
    return {
      processedViews: [],
      intervalId: null,
      dealers: null
    }
  },

  name: 'MostViewedCarousel',
  props: ['moreViews'],
  computed: {
    ...mapState('favorite', {
      favorites: state => state.vehicles,
    }),
    favoriteIds() {
      return new Set(this.favorites.map(f => f.id_avaliacao));
    }
  },
  async mounted() {
    await this.$store.dispatch("favorite/getFavorites")
    this.processCars();
    this.startTimer();
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  watch: {
    moreViews: {
      handler() {
        if (this.moreViews && this.moreViews.length) {
          this.processCars();
          if (!this.intervalId) this.startTimer();
        }
      },
      immediate: true,
    }
  },
  methods: {
    gotoCarMoreViews,
    isVehicleFavorite(vehicleId) {
      return this.favoriteIds.has(vehicleId);
    },
    processCars() {
      this.processedViews = this.moreViews.map(car => {
        car.url = `/avaliacoes/${car.empresa_url}/${car.id_avaliacao}/${car.v_marca}-${car.v_modelo}-${car.v_versao}`
        car.data = car.v_anof + '/' + car.v_anom
        if (car.qtdeVeic > 1) {
          car.url = `/avaliacoes/${car.empresa_url}/${car.id_avaliacao}/${car.v_marca.split(',')[0]}-${car.v_modelo}-${car.v_versao}`
          car.v_modelo = car.v_modelo.split(',')[0]
          car.data = `${car.qtdeVeic} VEÍCULOS`
          car.v_combustivel = ''
        }
        const now = Math.floor(Date.now() / 1000);
        let valor = 'Em Breve';
        let prefix = 'Inicia em';
        let timestamp = car.dt_ts_inicial;

        if (now >= car.dt_ts_inicial) {
          prefix = '';
          if (car.exibeVlrMin === 'S' || car.exibeTemInteresse === 'S') {
            valor = car.valor_avaliado || car.valor_inicial;
          } else if (car.exibeComprePor === 'S') {
            valor = car.valor_compra_arremate;
          }
          timestamp = car.dt_ts_final;
        }
        car.favorito = this.favorites.some(fav => fav.id_avaliacao === car.id_avaliacao);

        return {
          ...car,
          foto: car.foto === null ? require('@/assets/images/VehicleItemImage.png') : car.foto,
          valor: valor !== 'Em Breve'
            ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)
            : valor,
          remainingTime: this.calculateRemainingTime(timestamp),
          remainingPrefix: prefix,
        };
      });
    },
    startTimer() {
      this.intervalId = setInterval(() => {
        this.processedViews = this.processedViews.map(car => ({
          ...car,
          remainingTime: this.calculateRemainingTime(car.dt_ts_final)
        }));
      }, 1000);
    },
    calculateRemainingTime(endTimestamp) {
      const now = Math.floor(Date.now() / 1000);
      let secondsLeft = endTimestamp - now;

      if (secondsLeft <= 0) return "Encerrado";

      const days = Math.floor(secondsLeft / 86400);
      const hours = Math.floor((secondsLeft % 86400) / 3600);
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;

      if (secondsLeft > 86400) {
        return `${days}dias ${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
      } else {
        return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
      }
    },
    pad(num) {
      return num < 10 ? '0' + num : num;
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

.custom-desc {
  width: 100%;
}

.custom-card {
  background-color: white;
  border-radius: 8px;
  width: 100%;
}

.custom-carousel {
  position: relative;
  padding-top: 50px;
  width: 80%;
}

.custom-carousel>>>.v-carousel__controls {
  top: 0;
  bottom: auto;
  position: absolute;
  justify-content: end;
}

.more {
  color: white;
  position: relative;
  bottom: 12px;
}

.heart-icon {
  position: absolute;
  top: 8px;
  left: 8px;
  cursor: pointer;
  z-index: 2;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
}

.carousel-header {
  position: absolute;
  color: white;
  height: 40px;
  display: flex;
  align-items: end;
}
</style>
